import { gql } from "lib/apolloClient";
import { projectUserFragment } from "Projects/modules/ProjectFragments";

export const academicHonestyFragment = {
  basicDetails: gql`
    fragment academicHonestyItem on ProjectAcademicHonesty {
      id
      description
      meetingDate
      isRead
      isLocked
      isStarred
      displaySequence
      lockingState {
        state
        scheduledAt
      }
      createdBy {
        ...userItem
      }
    }
    ${projectUserFragment.basicUser}
  `,
  remarksDetails: gql`
    fragment remarksDetailsItem on Remark {
      id
      message
      isLocked
      lockingState {
        state
        scheduledAt
      }
      createdAt
      createdBy {
        ...userItem
      }
    }
    ${projectUserFragment.basicUser}
  `,
};
